import configs from 'configs';
import request from 'functions/api/request';
import { authHeaders, formAuthHeaders, getBasicHeaders } from 'functions/authHeader';

const { beApiUrl: apiUrl } = configs;

export const getTargetUserProfile = async ({ accessToken, lang }) => {
  const requestOptions = {
    url: `${apiUrl}/user/profile`,
    qs: {
      lang: lang || null,
    },
    headers: {
      ...getBasicHeaders(),
      ...formAuthHeaders({ accessToken }),
    },
    json: true,
  };

  let response = null;
  try {
    response = await request.get(requestOptions);
  } catch (ex) {
    console.error('Error occurred, while getting target user profile', ex);
    throw ex;
  }

  return response;
};

export const detachUserProvider = async (data) => {
  let response = null;

  const requestOptions = {
    url: `${apiUrl}/user/provider/detach`,
    headers: await authHeaders(),
    data,
    json: true,
  };

  try {
    response = await request.post(requestOptions);
  } catch (ex) {
    console.error('Error occurred, while trying to save provider info', ex);
    throw ex;
  }

  return response;
};

export const saveProviderInfo = async (data) => {
  let response = null;

  const requestOptions = {
    url: `${apiUrl}/user/statistic/saveProviderInfo`,
    headers: await authHeaders(),
    data,
    json: true,
  };

  try {
    response = await request.post(requestOptions);
  } catch (ex) {
    console.error('Error occurred, while trying to save provider info', ex);
    throw ex;
  }

  return response;
};

export const createLoginToken = async () => {
  let response = null;

  const requestOptions = {
    url: `${apiUrl}/user/email/token`,
    headers: await authHeaders(),
    json: true,
  };

  try {
    response = await request.get(requestOptions);
  } catch (ex) {
    console.error('Error occurred, while trying to create emails token', ex);
    throw ex;
  }

  if (!response.success) {
    throw new Error('Failed while trying to create emails token');
  }

  return response.data;
};

export const getDoctors = async (data) => {
  let response = null;

  const requestOptions = {
    url: `${configs.beApiUrl}/user/search-doctor`,
    qs: {
      name: data?.name,
      limit: data?.limit || null,
    },
    headers: await authHeaders(),
    json: true,
  };

  try {
    response = await request.get(requestOptions);
  } catch (ex) {
    console.error('Error occurred, while getting user profile', ex);
    throw ex;
  }

  return response;
};

export const addDoctor = async (data) => {
  let response = null;

  const requestOptions = {
    url: `${configs.beApiUrl}/user/add-doctor`,
    data,
    headers: await authHeaders(),
    json: true,
  };

  try {
    response = await request.post(requestOptions);
  } catch (ex) {
    console.error('Error occurred, while getting user profile', ex);
    throw ex;
  }

  return response;
};

export const getFieldsUpdateDates = async () => {
  const requestOptions = {
    url: `${apiUrl}/profile/userAnswersDates`,
    headers: await authHeaders(),
    json: true,
  };

  try {
    return await request.get(requestOptions);
  } catch (ex) {
    console.error('getFieldsUpdateDates: Error occurred:', ex);
    throw ex;
  }
};
